import React, { ReactNode, Component } from 'react';
import { initDataDog, addError, logError } from './datadogHelpers';
import Result from 'antd/lib/result';
import Button from 'antd/lib/button';

initDataDog();

type State = {
  hasError: boolean;
};
type Props = {
  children: ReactNode;
};

class DataDogErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const renderingError = new Error(error.message);
    renderingError.name = 'ReactRenderingError';
    renderingError.stack = errorInfo.componentStack;
    renderingError.cause = error;

    addError(renderingError);
    // Log error to Datadog
    logError(error.toString(), errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Result
          status='404'
          title='Oops Something went wrong.'
          extra={
            <a href='/'>
              <Button type='primary'>Back Home</Button>
            </a>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default DataDogErrorBoundary;
